import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, SystemJsNgModuleLoader, ViewChild, ViewContainerRef } from '@angular/core';
import { alert } from 'devextreme/ui/dialog';
import { FormsTemplateService } from '../../../services/forms-template.service';
import { messagefromComponent } from '../../../class/appinterface';
import { unescapeIdentifier } from '@angular/compiler';
import { NicaFormComponent } from '../../nica-form/nica-form.component';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { switchMap, tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';

///import { OverlaySideFormComponent } from '../../shared/overlay-side-form/overlay-side-form.component';
/*
export interface IAnagraficaAziendaInfo{

  //soggetto?:string;
  PIvaAzienda?:string;
  codiceFiscale?:string;
  ragione_Sociale?:string;
  indirizzo?:string;
  localita?:string;
  cap?:string;
  provincia?:string;
  regione?:string;
  tax?:string;
  vat?:string;
  crifNumber?:string;
  statoAttivita?:string;
  pec?:string;

}
*/

export interface IPartitaIVAResponse {
  tax: string;
  indirizzo: string;
  cap: string;
  ragione_Sociale: string;
  vat: string;
  regione: string;
  localita: string;
  prov: string;
  crifnumber: string;
  pec: string;
  statoattivita: string;
}

interface RootObject {
  msg: IPartitaIVAResponse;
  status: string;
}


@Component({
  selector: 'app-nica-info-anagrafica-azienda',
  templateUrl: './nica-info-anagrafica-azienda.component.html',
  styleUrls: ['./nica-info-anagrafica-azienda.component.css']
})
export class NicaInfoAnagraficaAziendaComponent implements OnInit, AfterViewInit, OnDestroy {

  constructor(private http: HttpClient, 
    private changeDetectorRef: ChangeDetectorRef,
    private spinner: NgxSpinnerService
  ) { }


  @ViewChild("infoImpresa", { static: true }) infoImpresa: NicaFormComponent;


  @Input() itemData: any; //Serve per ottenere partita iva o cf da esterno
  @Output() emittedData: EventEmitter<IPartitaIVAResponse | Object> = new EventEmitter<IPartitaIVAResponse | Object>(); //Emit all'esterno

  formDataJSON: any;
  spinnerVisibile: boolean = true;
  /*
  aziendaFormData:IAnagraficaAziendaInfo={
   
    partitaIVA:undefined,
    codiceFiscale:undefined,
    indirizzo:undefined,
    localita:undefined,
    cap:undefined,
    provincia:undefined,
    regione:undefined,
    tax:undefined,
    crifNumber:undefined,
    statoAttivita:undefined,
    pec:undefined

  };
  */
  buttonCustom: any[];

  ngOnInit() {
console.log('stampo itemData in ingresso',this.itemData)
    this.spinnerVisibile = true;
    this.spinner.show()
    //document.getElementById("datiImpresa").style.display="none";


    /*
    
      {
                        location: "before",
                        widget: "dxButton",
                        locateInMenu: "never",
                        text: 'Salva dati Accettazione',
                        icon: "glyphicon mdi mdi-content-save-outline",
                        event: 'SalvaDatiAccettazione'

                      }
    */

    this.buttonCustom = [
      {
        location: "after",
        stylingMode: "text",
        widget: "dxButton",
        locateInMenu: "never",
        text: 'Incolla',
        icon: "glyphicon icon-salva-form",
        event: 'incollaDatiImpresa',

      },

      {
        location: "after",
        stylingMode: "text",
        widget: "dxButton",
        locateInMenu: "never",
        text: 'Annulla',
        icon: "glyphicon glyphicon icon-annulla-form",
        event: 'annullaDatiImpresa',

      },
    ];

  }


  async ngAfterViewInit(): Promise<void> {
    //this.subjectCall //= this.templateServie.getService("infoImpresa");
    //this.inizializza("0");

    await this.inizializza();

    //this.changeDetectorRef.detectChanges();
  }


  //Data una p. IVA o CF, le informazioni correlate a tale impresa vengono immesse nel formData
  public async inizializza(): Promise<void> {


    if (!this.itemData)
      return;

    let partitaIva_codiceFiscale: string = typeof this.itemData[0]["dati"] === "string" ? (this.itemData[0]["dati"] as string).trim() : (this.itemData[0]["dati"]["current"] as string).trim();

    //console.log(partitaIva_codiceFiscale);
    /*
    if(partitaIva_codiceFiscale.length == 0)
      return;
    */
    let obj = await this.getInformazioniImpresa(partitaIva_codiceFiscale);

    if (!obj || obj == null) {

      this.spinnerVisibile = false;
      this.spinner.hide()
      let mesError = '';
      
        mesError = "Non è presente , nel registro delle imprese, nessuna azienda avente il Codice Fiscale/Partita IVA inserito!";



      alert(mesError, "Attenzione").then(rs => {

        let datiOutput= {

          eventName: 'annullaDatiImpresa'
        }
  
        
        this.emittedData.emit(datiOutput);

        //this.componentService.emitMessage(messaggioChiusura);


      });
      return;
    }
    else if(!Object.values(obj).some((value:string)=> value.length>0))
    {

      this.spinnerVisibile = false;
      this.spinner.hide()
      let mesError = '';
      
      mesError = "Codice Fiscale/Partita IVA non valido";



      alert(mesError, "Attenzione").then(rs => {

        let datiOutput= {
          eventName: 'annullaDatiImpresa'
        }
  
        
        this.emittedData.emit(datiOutput);

        //this.componentService.emitMessage(messaggioChiusura);


      });
      return;

    }





    this.spinnerVisibile = false;
    this.spinner.hide()
    //this.formDataJSON[0] = obj["msg"];


    //console.log("Ecco daImpresaaaaaaaaaa ",obj);




    obj["soloDati"] = true;
    obj["soloPec"] = false;

    obj["civico"] = !isNaN(parseInt((obj["indirizzo"] as string).split(",")[1].trim())) ? (obj["indirizzo"] as string).split(",")[1].trim() : '';
    obj["indirizzo"] = (obj["indirizzo"] as string).split(",")[0];


    this.formDataJSON = obj
    //this.infoImpresa.dataSet =(obj as any); //così funziona apparentemente



    // document.getElementById("datiImpresa").style.display="block";










  }

  emettiEventoPulsante(evt) {

 
    if (evt == 'close') {
      let datiOutput= {

        eventName: 'annullaDatiImpresa'
      }

      
      this.emittedData.emit(datiOutput);


    }
    if (evt == 'annullaDatiImpresa') {

      /*
      let messaggio: messagefromComponent = {
        codeMessage: -5,
        destComponent: this.itemData[0].destComponent, //"trasportatori",
        traceMessage: this.itemData[0].traceMessage, //'infoPIVA',

      }
      */

      let datiOutput= {

        eventName: 'annullaDatiImpresa'
      }

      
      this.emittedData.emit(datiOutput);




      return;
    }

    if (evt == 'incollaDatiImpresa') {

      //console.warn(this.formDataJSON,'test');

      if (!this.formDataJSON)
        return;

      const datiOutput = this.formDataJSON;
      datiOutput.eventName = 'incollaDatiImpresa'

      /*
      let messaggio: messagefromComponent = {
        codeMessage: 90,
        destComponent: this.itemData[0].destComponent, //"trasportatori",
        traceMessage: this.itemData[0].traceMessage, //'infoPIVA',
        Data: {
          Items: datiOutput
        }
      }

      if (this.itemData[0]["dati"]["backup"])
        messaggio.Data["backup"] = this.itemData[0]["dati"]["backup"];
      */
      //console.log(datiOutput)
      // this.componentService.emitMessage(messaggio);


      this.emittedData.emit(datiOutput)
    }

    /*
    const datiOutput :any[]= this.formDataJSON;


    if(!datiOutput['soloDati'] && !datiOutput['soloPec']){


      alert("Spuntare almeno una delle due opzioni","Attenzione");

    
      return;
    }

    let messaggio : messagefromComponent ={
      codeMessage:90,
      destComponent: this.itemData.destComponent, //"trasportatori",
      traceMessage: this.itemData.traceMessage, //'infoPIVA',
      Data:{
        Items:datiOutput
      }
    }

    if(this.itemData[0]["dati"]["backup"])
        messaggio.Data["backup"] = this.itemData[0]["dati"]["backup"];

    //this.componentService.emitMessage(messaggio);

    this.emittedData.emit(datiOutput)
    */
  }


  ngOnDestroy(): void {


    //this.formDataJSON=undefined;
    this.spinnerVisibile = true;
    this.spinner.hide()
    // document.getElementById("datiImpresa").style.display="none";

  }

  private getAPI_URL(pivaCodfisDaRicercare: string): string {
    return environment.BASE_API_URL.concat(`Utility/GetInformazioniImpresa/${pivaCodfisDaRicercare}`);
  }

  private getInformazioniImpresa(pivaCodfisDaRicercare: string): Promise<IPartitaIVAResponse> {

    return this.http.get<RootObject>(
      environment.BASE_API_URL.concat(`Utility/GetInformazioniImpresa/${pivaCodfisDaRicercare}`)
    ).pipe(
      tap(dati => console.log(dati)),
      switchMap(async (dati: RootObject) => dati.msg)
    ).toPromise();


  }

  /** Ritorna una Guard per capire se è di quell'interfaccia TS */
  public static isMsgPartitaIVA = (partitaIVARes: IPartitaIVAResponse): partitaIVARes is IPartitaIVAResponse => {
    return 'tax' in partitaIVARes;
  }
}









